"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useColorPickerConverter;
exports.hsl2hsv = hsl2hsv;
exports.stringToColorResult = stringToColorResult;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _color = _interopRequireDefault(require("color"));
var _react = require("react");
function colorResultToString(colorResult) {
  var _colorResult$rgb;
  if (((_colorResult$rgb = colorResult.rgb) === null || _colorResult$rgb === void 0 ? void 0 : _colorResult$rgb.a) !== 1) {
    var _colorResult$rgb2 = colorResult.rgb,
      r = _colorResult$rgb2.r,
      g = _colorResult$rgb2.g,
      b = _colorResult$rgb2.b,
      a = _colorResult$rgb2.a;
    return (0, _color["default"])({
      r: r,
      g: g,
      b: b
    }).alpha(a).toString();
  }
  return colorResult.hex;
}
function hsl2hsv(hslH, hslS, hslL) {
  var hsv1 = hslS * (hslL < 50 ? hslL : 100 - hslL) / 100;
  var hsvS = hsv1 === 0 ? 0 : 2 * hsv1 / (hslL + hsv1) * 100;
  var hsvV = hslL + hsv1;
  return {
    h: hslH,
    s: hsvS,
    v: hsvV
  };
}
function stringToColorResult(color) {
  var colorObj = (0, _color["default"])(color || '#131416');
  var _colorObj$rgb = colorObj.rgb(),
    _colorObj$rgb$color = (0, _slicedToArray2["default"])(_colorObj$rgb.color, 3),
    r = _colorObj$rgb$color[0],
    g = _colorObj$rgb$color[1],
    b = _colorObj$rgb$color[2],
    valpha = _colorObj$rgb.valpha;
  var _colorObj$hsl = colorObj.hsl(),
    _colorObj$hsl$color = (0, _slicedToArray2["default"])(_colorObj$hsl.color, 3),
    h = _colorObj$hsl$color[0],
    s = _colorObj$hsl$color[1],
    l = _colorObj$hsl$color[2];
  var _colorObj$hsv = colorObj.hsv(),
    _colorObj$hsv$color = (0, _slicedToArray2["default"])(_colorObj$hsv.color, 3),
    _h = _colorObj$hsv$color[0],
    _s = _colorObj$hsv$color[1],
    _v = _colorObj$hsv$color[2];
  return {
    hex: color,
    hsl: {
      h: h,
      s: s,
      l: l,
      a: valpha
    },
    rgb: {
      r: r,
      g: g,
      b: b,
      a: valpha
    },
    hsv: {
      h: _h,
      s: _s,
      v: _v,
      a: valpha
    }
  };
}
function useColorPickerConverter(selectedColor, onChange) {
  var color = (0, _react.useMemo)(function () {
    return stringToColorResult(selectedColor);
  }, [selectedColor]);
  var _onChange = (0, _react.useCallback)(function (colorResult) {
    return onChange(colorResultToString(colorResult));
  }, [onChange]);
  return {
    color: color,
    onChange: _onChange
  };
}
//# sourceMappingURL=useColorPickerConverter.js.map